import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
    selector: 'app-finish',
    templateUrl: './finish.component.html',
    styleUrls: ['./finish.component.scss']
})
export class FinishComponent implements OnInit {

    constructor(private router: Router) { }
    @Input() point: number = 0;
    @Input() time: number = 0;
    @Input() image: string = '';
    @Input() title: string = '';
    timeString: any = null;

    done(): void {
        if (this.image) {
            this.router.navigate(['/finish'], { queryParams: { g: this.image } });
        } else {
            this.router.navigate(['/home'], { replaceUrl: true });
        }
    }
    ngOnInit(): void {
        this.timeString = moment.duration((this.time).toFixed(1), 'seconds').asSeconds() + ' Seconds';
    }

}
